//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as types from '../../store/mutation-types.js'
import base64url from 'base64-url'

export default {
  props: ['photos', 'isLoad'],
  data() {
    return {
      arr: [],
      scrollDisabled: false,
      checkMode: false,
      checkList: []
    }
  },
  computed: {
    picCount() {
      return this.$store.state.live.detail.PublishPicturesCount
    },

    pageIndex() {
      return this.$store.state.live.pageIndex
    },
    list() {
      return this.initPhotoList(this.photos)
    },
    previewerList() {
      return this.initPreviewPhotoList(this.photos)
    },
    pic_width() {
      return (this.$store.state.base.viewWidth - 8) / 3 + 'px'
    },
    pic_height() {
      return (this.$store.state.base.viewWidth - 8) / 4 + 'px'
    },
    large_pic_width() {
      return this.$store.state.base.viewWidth - 4 + 'px'
    },
    large_pic_height() {
      return (this.$store.state.base.viewWidth - 4) / 16 * 9 + 'px'
    }
  },
  methods: {
    // 初始化照片列表
    initPhotoList(list) {
      let arr = []
      if (list) {
        list.map((item, index) => {
          if (item.IsLarge) {
            arr.push({
              pic: item,
              url: this.initQiniu(item.Url, true)
            })
          } else {
            arr.push({
              pic: item,
              url: this.initQiniu(item.Url, false)
            })
          }
        })
        this.$nextTick(() => {
          this.scrollDisabled = false
          this.$vux.loading.hide()
        })
      }
      return arr
    },

    // 切换拼图功能选项
    toggleMode() {
      this.checkList = []
      this.checkMode = !this.checkMode
    },

    // 显示预览图
    show(index) {
      this.$emit('showPre', index)
    },
    isChecked(id) {
      return this.checkList.indexOf(id) == -1 ? false : true
    },
    checkThis(id) {
      let flag = false
      // 判断是否存在
      this.checkList.map((item, i) => {
        if (item == id) {
          this.checkList.splice(i, 1)
          flag = true
        }
      })

      if (!flag) {
        // 插入元素
        if (this.checkList.length > 4) {
          alert('最多只能选择5张拼图~')
          return
        }
        this.checkList.push(id)
      }
    },
    checkOK() {
      if (this.checkList.length <= 0) {
        alert('至少选择一张图哦！')
        return
      }
      // 进行拼图
      this.$emit('startShot', this.checkList)
    },
    checkCancel() {
      // 取消拼图
      this.checkMode = false
      this.$emit('cancelShot')
    },

    // 拼接七牛参数
    initQiniu(link, isLarge) {
      if (isLarge) {
        // 首页大图尺寸为500*280
        return link + '?imageView2%2F1%2Fw%2F600%2Fh%2F450%2F'
      } else {
        // 首页小图尺寸为200*150
        return link + '?imageView2/1/w/200/h/150'
      }
    },

    infiniteLoad() {
      console.log('infiniteLoad', this.scrollDisabled)
      // 判断页面是否滚动到底部
      if (
        !this.scrollDisabled &&
        document.documentElement.offsetHeight != 0 &&
        document.documentElement.clientHeight + window.scrollY >=
          document.documentElement.offsetHeight
      ) {
        this.scrollDisabled = true
        // 加载数据
        if (this.photos.length < this.picCount) {
          this.loadMore()
        }
      }
    },

    loadMore() {
      // 触发父组件loadMore()
      this.$emit('loadMore')
    }
  },
  mounted() {
    // 初始化监听页面滚动
    window.addEventListener('scroll', this.infiniteLoad, false)
  }
}



// WEBPACK FOOTER //
// ./src/components/InfiniteScroller/InfiniteScroller.vue